import { useEffect, useState } from 'react'
import { APP_ENV } from '@/config-global.jsx'
import { handleError } from '@/services/errorHandler.js'

export const useNewVersionPolling = () => {

    const [newVersionAvailable, setNewVersionAvailable] = useState(false)

    const checkNewVersions = async () => {
        try {
            if (newVersionAvailable) {
                return
            }
            // Query the server for the latest version
            const response = await fetch(location.origin, { cache: "no-cache" })
            const html = await response.text()
            const parser = new DOMParser()
            const doc = parser.parseFromString(html, 'text/html')

            // Compare the versions
            const currentLocalVersion = document.querySelector('meta[name="deployment-version"]').getAttribute('content')
            const currentAvailableVersion = doc.querySelector('meta[name="deployment-version"]').getAttribute('content')
            if (currentLocalVersion !== currentAvailableVersion) {
                setNewVersionAvailable(true)
            }
        } catch (e) {
            handleError(e)
        }
    }

    useEffect(() => {
        if (APP_ENV === 'local') {
            return
        }
        const interval = setInterval(checkNewVersions, 1000 * 60 * 5) // Check every 5 minutes
        return () => clearInterval(interval)
    }, [])


    return newVersionAvailable


}